import { useVoiceAssistant } from '@livekit/components-react'
import { BarVisualizer } from '@livekit/components-react'

export function AudioInputTile() {
  const { audioTrack } = useVoiceAssistant()

  return (
    <div className="flex flex-col gap-2 h-full p-4">
      <h3 className="text-sm font-medium text-muted-foreground">Audio Input</h3>
      {audioTrack ? (
        <div className="flex-1 flex items-center justify-center">
          <BarVisualizer
            state="speaking"
            barCount={5}
            trackRef={audioTrack}
            className="w-full h-16"
          />
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center text-muted-foreground">
          No audio input
        </div>
      )}
    </div>
  )
}
